import { post, type RequestConfig } from "../shared/api-client";
import {
  JIVANDHARA_BASE,
  isApiItemResponse,
  unwrapItem,
} from "../admin/list-api-helpers";
import {
  parseCreateOrderResponse,
  parseVerifyPaymentResponse,
  type DonationCreateOrderPayload,
  type DonationCreateOrderResult,
  type DonationVerifyPaymentPayload,
  type DonationVerifyPaymentResult,
} from "@project/types/donation-payment";

const SILENT: RequestConfig = { showNotification: false };

class PublicDonationPaymentService {
  createOrder = async (
    payload: DonationCreateOrderPayload
  ): Promise<DonationCreateOrderResult> => {
    const response = await post<unknown, DonationCreateOrderPayload>(
      `${JIVANDHARA_BASE}/donations/create-order/`,
      payload,
      SILENT
    );
    const parsed = parseCreateOrderResponse(
      unwrapItem(response) ?? (response as object)
    );
    if (!parsed.order_id) {
      throw new Error("Failed to create payment order.");
    }
    return parsed;
  };

  verifyPayment = async (
    payload: DonationVerifyPaymentPayload
  ): Promise<DonationVerifyPaymentResult> => {
    const response = await post<unknown, DonationVerifyPaymentPayload>(
      `${JIVANDHARA_BASE}/donations/verify-payment/`,
      payload,
      SILENT
    );
    if (isApiItemResponse(response)) {
      return parseVerifyPaymentResponse(response.data ?? response);
    }
    return parseVerifyPaymentResponse(
      (unwrapItem(response) ?? response) as DonationVerifyPaymentResult
    );
  };
}

export const publicDonationPaymentService = new PublicDonationPaymentService();
